import { DISABLE_PARENT_CALENDAR_TIMER } from "../actions/types";

export default (val = false, action) => {
  if (action.type === DISABLE_PARENT_CALENDAR_TIMER) {
    return action.payload;
  }
  return val;
};
